import React from "react";
import { Button as ShadCNButton } from "@/components/ui/button";

type ButtonPropsType = {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  type?: React.ButtonHTMLAttributes<HTMLButtonElement>["type"];
  className?: React.ButtonHTMLAttributes<HTMLButtonElement>["className"];
};

function Button({ children, onClick, type, className: customClassName, ...props }: ButtonPropsType) {
  const className = `${customClassName} border-2 border-transparent bg-gray-800 px-3 py-2 rounded hover:bg-gray-900 hover:border-solid hover:border-2 hover:border-gray-300 duration-300 text-white hover:shadow-xl`;
  return (
    <ShadCNButton className={className} onClick={onClick} type={type} {...props}>
      {children}
    </ShadCNButton>
  );
}

export default Button;
